import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BadgeColor } from 'components/cs-badge/cs-badge';
import { TextAlertType } from 'components/cs-text-alert/cs-text-alert';
import { CsInfoCardType } from 'components/cs-info-card/cs-info-card';
import { StepConfig, StepperStyle, StepState } from 'components/cs-stepper/cs-stepper';
import { ExerciseStatusBadgeType } from 'components/cs-exercise-status-badge/cs-exercise-status-badge';
import { StatusIconSize, StatusIconTone } from 'components/cs-status-icon/cs-status-icon';
import { RepProgressBarTone } from 'components/cs-rep-progress-bar/rep-progress-bar-tone';

// The Status & Feedback card's body on the Test UI Components page (#6020): badges, alerts, info
// cards, empty states, loading placeholders, steppers and progress bars, with literal sample data.
@Component({
  selector: 'cs-test-status-feedback-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-status-feedback-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestStatusFeedbackCardComponent {
  readonly badgeColors: BadgeColor[] = [BadgeColor.Blue, BadgeColor.Purple, BadgeColor.Magenta, BadgeColor.Yellow,
    BadgeColor.Red, BadgeColor.Green, BadgeColor.Gray, BadgeColor.Light, BadgeColor.TextOnly];
  readonly textAlertTypes: TextAlertType[] = ['warning', 'success', 'success-strong', 'error', 'neutral', 'info'];
  readonly infoCardTypes: CsInfoCardType[] = ['info', 'warning', 'error', 'success', 'checkmark', 'translucent'];
  readonly StepperStyle = StepperStyle;
  readonly stepperSteps: StepConfig[] = [
    { label: 'Goal', state: StepState.Complete },
    { label: 'Body', state: StepState.Partial },
    { label: 'Diet', state: StepState.Current },
    { label: 'Plan', state: StepState.Pending },
  ];
  readonly ExerciseStatusBadgeType = ExerciseStatusBadgeType;
  readonly StatusIconTone = StatusIconTone;
  readonly StatusIconSize = StatusIconSize;
  readonly RepProgressBarTone = RepProgressBarTone;

  showSpinner = false;
}
